import { render, staticRenderFns } from "./fenqu.vue?vue&type=template&id=69454b29&scoped=true"
import script from "./fenqu.vue?vue&type=script&lang=js"
export * from "./fenqu.vue?vue&type=script&lang=js"
import style0 from "./fenqu.vue?vue&type=style&index=0&id=69454b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69454b29",
  null
  
)

export default component.exports